import axios from '../../axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TSubmitForm, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';
import type { TFormSubmission } from './start-submission';

export interface TFormSubmissionAnswer {
  id: string;
  submissionId: string;
  questionId: string;
  selectedOptionIds: string[];
  orderingSequence: string[];
  textAnswer: string | null;
  fileUrls: string[];
}

export interface TSubmittedForm extends TFormSubmission {
  answers: TFormSubmissionAnswer[];
}

interface SubmitFormInput {
  submissionId: string;
  data: TSubmitForm;
}

/**
 * Hook to submit a form (persist answers, mark as submitted)
 */
export const useSubmitForm = () => {
  const queryClient = useQueryClient();

  return useMutation<TSubmittedForm, TError, SubmitFormInput>({
    mutationFn: async ({ submissionId, data }) => {
      const res = await axios.post<TSubmittedForm>(`/community-hub/form-submissions/${submissionId}/submit`, data);
      return res.data;
    },
    onSuccess: (result, { submissionId }) => {
      queryClient.setQueryData([ENTITY, 'form-submission', submissionId], result);
      queryClient.invalidateQueries({ queryKey: [ENTITY, 'form', result.formId, 'submissions'] });
    },
  });
};
